import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  useRedirect,
  useNotify,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import ResourceBreadcrumbsWithActions from '../../components/ResourceBreadcrumbsWithActions';

export const RegionCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSuccess = () => {
    notify('Region created successfully');
    redirect('/regions');
  };

  return (
    <Create resource="regions" redirect={false} onSuccess={handleSuccess}>
      <SimpleForm>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Create New Region
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Add a new geographic region for franchise management
          </Typography>
        </Box>

        <TextInput
          source="name"
          label="Region Name"
          validate={[{ required: 'Region name is required' }]}
          fullWidth
        />

        <TextInput
          source="description"
          label="Description"
          multiline
          rows={3}
          fullWidth
        />

        <SelectInput
          source="brandId"
          label="Brand"
          optionText="name"
          optionValue="id"
          validate={[{ required: 'Brand is required' }]}
          fullWidth
        />

        <TextInput
          source="location"
          label="Location"
          placeholder="e.g., North America, Europe"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};
